import { type Meta } from '../types/docs';

const META: Meta = {
  name: 'logged_out_user_due_to_inactivity',
  description: 'User is logged out due to inactivity',
};

export default META;
